<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
    v-if="critereRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon
            class="icon is-pulled-right has-text-icon-more"
            icon="close">
          </b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless hauteur-brief-filtre">
      <div class="column is-12 pdb-0">
        <libelle-tag-input
          :label="$t('previsionnelDepart.filtre.type')"
          :items="constantes.LISTE_TYPE_DEVIS_COMMANDE"
          v-model="typesSelected">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('previsionnelDepart.filtre.codesCommandes')">
          <qd-taginput
            type="is-primary"
            v-model="critereRecherche.codesDcf">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <user-tag-input
          v-model="commercialSelected"
          :label="$t('listeLignesCommande.filtre.commercial')"
          :blocked="userIsCommercialBlocked"
          :items="listeCommercial">
        </user-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <user-tag-input
          v-model="assistantSelected"
          :label="$t('listeLignesCommande.filtre.assistant')"
          :items="listeAssistant">
        </user-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <agence-tag-input
          :label="$t('previsionnelDepart.filtre.agences')"
          :items="agencesSelectionnees"
          v-model="critereRecherche.agencesIdProduit">
        </agence-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('previsionnelDepart.filtre.instructionPose')">
          <b-input v-model="critereRecherche.instructionPose">
          </b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('previsionnelDepart.filtre.afficheLivre')">
          <b-select v-model="critereRecherche.afficheLivre">
            <option :value="null"></option>
            <option :value="true"> {{ $t('general.oui') }} </option>
            <option :value="false"> {{ $t('general.non') }} </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('previsionnelDepart.filtre.theme')">
          <b-input v-model="critereRecherche.theme">
          </b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('previsionnelDepart.filtre.libelleReseau')">
          <b-input v-model="critereRecherche.libelleProduit">
          </b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('previsionnelDepart.filtre.villes')">
          <ville-tag-input-auto-complete
            :critere-recherche="critereRecherche"
            table-name="Produit"/>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <input-periode
          v-model="critereRecherche.dates"
          :label="$t('previsionnelDepart.filtre.datesAffichage')"
          orientation="top">
        </input-periode>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('previsionnelDepart.filtre.semaineVente')">
          <b-datepicker
            v-model="critereRecherche.dateAnneeSemaine"
            :date-formatter="formatageOuputDatepicker"
            icon="calendar-today"
            nearby-selectable-month-days
            show-week-number
            editable>
          </b-datepicker>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <libelle-tag-input
          :label="$t('previsionnelDepart.filtre.jourDepart')"
          :items="getListeJourDepart"
          v-model="jourDepartSelected"
          field="libelle">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('previsionnelDepart.filtre.nbFacesVendues')">
          <div class="columns is-vcentered">
            <b-input
              v-model="critereRecherche.qteMinFacesVendues"
              type="number"
              class="column"/>
            <span class="column is-narrow is-size-7">
              {{ $t('general.et') }}
            </span>
            <b-input
              v-model="critereRecherche.qteMaxFacesVendues"
              type="number"
              class="column"/>
          </div>
        </b-field>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('listeFace.filtre.actions.appliquer')}}
      </button>
      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('listeFace.filtre.actions.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import { LISTE_TYPE_DEVIS_COMMANDE } from '@/configuration/devisConf';
import getAnneeSemaineFromDate from '@/services/general/getAnneeSemaineFromDate';
import formatDate from '@/services/general/formatDate';
import { LISTE_INDEX_JOURS } from '@/configuration/datePickerConf';
import ucFirst from '@/services/general/ucFirst';
import { SET_CRITERE_PREVISIONNEL_CBA } from '@/store/modules/ligneCommande-mutation-type';
import genererCritereRecherchePrevisionnelCBA
  from '@/services/ligneCommande/genererCritereRecherchePrevisionnelCBA';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import * as userConfig from '@/configuration/parametrage/utilisateurConf';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';
import initialUsers from '@/services/general/filters/filterinitUsers';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import userTagInput from '@/components/general/tagInput/userTagInput';
import inputPeriode from '@/components/general/inputPeriode';
import VilleTagInputAutoComplete from '@/components/commun/ville/villeTagInputAutoComplete';

const LigneCommande = createNamespacedHelpers('ligneCommande');
const Societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      critereRecherche: null,
      listeCommercial: [],
      commercialSelected: [],
      listeAssistant: [],
      assistantSelected: [],
      jourDepartSelected: [],
      typesSelected: [],
      constantes: {
        LISTE_TYPE_DEVIS_COMMANDE,
      },
    };
  },
  components: {
    agenceTagInput,
    userTagInput,
    VilleTagInputAutoComplete,
    inputPeriode,
    libelleTagInput,
  },
  computed: {
    ...LigneCommande.mapGetters({
      critereRechercheFromStore: 'criteresRecherchePrevisionnelCBA',
    }),
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActive: 'societeActive',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    blocageFiltreCommercial() {
      return this.parametresInterne(
        PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
      );
    },
    userIsCommercial() {
      return (this.user.profil === userConfig.COMMERCIAL);
    },
    userIsCommercialBlocked() {
      return this.userIsCommercial && this.blocageFiltreCommercial;
    },
    getListeJourDepart() {
      const listeJour = cloneDeep(LISTE_INDEX_JOURS);
      listeJour.forEach((jour) => {
        jour.libelle = ucFirst(jour.libelle);
      });
      return listeJour;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...LigneCommande.mapMutations({
      setCritereRecherche: SET_CRITERE_PREVISIONNEL_CBA,
    }),
    formatageOuputDatepicker(date) {
      const semaine = (getAnneeSemaineFromDate(date)).substr(4);
      const dateDebut = moment(date).startOf('week').toDate();
      const dateFin = moment(date).endOf('week').toDate();
      return this.$t('listeDemande.weekWithDate', {
        week: semaine, dateDebut: formatDate(dateDebut), dateFin: formatDate(dateFin),
      });
    },
    appliquerCritere() {
      this.critereRecherche.typesDevisCommandeFacture = this.typesSelected.map(el => {
        return el.code;
      });
      this.critereRecherche.commercialId = this.commercialSelected.map((c) => {
        return c.id;
      });
      this.critereRecherche.assistantId = this.assistantSelected.map((a) => {
        return a.id;
      });
      this.critereRecherche.jourDepart = this.jourDepartSelected.map((jourDepart) => {
        return jourDepart.number;
      });
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche');
    },
    async viderCritere() {
      const critere = cloneDeep(genererCritereRecherchePrevisionnelCBA());
      await updateCritereWithParametreInterne(critere);
      this.critereRecherche = critere;
      this.commercialSelected = this.critereRecherche.commercialId.map(id => {
        return this.listeCommercial.find(c => c.id === id) ?? {};
      });
      this.assistantSelected = this.critereRecherche.assistantId.map(id => {
        return this.listeAssistant.find(c => c.id === id) ?? {};
      });
      this.typesSelected = this.constantes.LISTE_TYPE_DEVIS_COMMANDE.filter((c) => {
        return this.critereRecherche.typesDevisCommandeFacture.includes(c.code);
      });
      this.jourDepartSelected = [];
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.critereRecherche = cloneDeep(this.critereRechercheFromStore);
        await this.loadParametreUtilisateur();
        await this.loadParametresInterne([
          PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
        ]);
        await updateCritereWithParametreInterne(this.critereRecherche);

        const users = this.parametre(PARAMETRES_KEYS.utilisateur)
          .filter(user => user.actif);
        this.listeAssistant = initialUsers(users, [userConfig.ASSISTANT_COMMERCIAL], this.$i18n.t('listeLignesCommande.filtre.sansAssistant'));
        this.listeCommercial = initialUsers(users, [userConfig.DIRECTEUR_COMMERCIAL, userConfig.COMMERCIAL], this.$i18n.t('listeLignesCommande.filtre.noCommercial'));

        this.commercialSelected = this.listeCommercial.filter((c) => {
          return this.critereRecherche.commercialId.includes(c.id);
        });
        this.assistantSelected = this.listeAssistant.filter((a) => {
          if (!this.critereRecherche.assistantId) return false;
          return this.critereRecherche.assistantId.includes(a.id);
        });
        if (this.critereRecherche.jourDepart) {
          this.jourDepartSelected = this.getListeJourDepart.filter((option) => {
            return this.critereRecherche.jourDepart.includes(option.number);
          });
        }
        this.typesSelected = this.constantes.LISTE_TYPE_DEVIS_COMMANDE.filter((c) => {
          return this.critereRecherche.typesDevisCommandeFacture.includes(c.code);
        });
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
